var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-flow"},[(_vm.isShowTips)?_c('Paper',{staticClass:"contract-flow-paper"},[_c('span',{staticClass:"tips"},[_vm._v(" 请切换LCRM合同管理模块查询："+_vm._s(_vm.contractCode)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }